function recalcDimensions() {
  const fullWidth = document.body.clientWidth;
  document.documentElement.style.setProperty('--nst-viewportWidth', `${fullWidth}px`);
}

function watchDimensions() {
  if (document.readyState === 'complete') {
    recalcDimensions();
  }
  else {
    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', recalcDimensions);
    }
    
    window.addEventListener('load', recalcDimensions);
  }

  window.addEventListener('resize', recalcDimensions);
}

export default {
  recalcDimensions, watchDimensions
}